import script from "./H5SelfAds.vue?vue&type=script&lang=ts&setup=true"
export * from "./H5SelfAds.vue?vue&type=script&lang=ts&setup=true"

import "./H5SelfAds.vue?vue&type=style&index=0&id=6cc6cd74&lang=css"

const __exports__ = script;

export default __exports__